import React from "react";
import { useEffect, useState,useCallback } from "react";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Variables } from "../../../Variations/Variations";
import { PaginatedList } from "react-paginated-list";
import Dropzone from "react-dropzone";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

function ProductImage(props) {
  const [Media, setMedia] = useState([]);
  const [show, setShow] = useState(false);
  const [filteredData, setFilteredData] = useState(Media);
  const [uploadedImages, setUploadedImages] = useState([]);
  const navigate = useNavigate();

  function handleShow(breakpoint) {
    setShow(true);
  }

  function handleImage(id,image) {
 
  props.setProductImage(id)
  props.setShowingProductImage(image)
  setShow(false)
  }



  const handleDrop = async (files) => {
    const token = Cookies.get("UserToken");
    let count = 0;
  
    for (let file of files) {
      if (file.size >= 2000000) {
        count++;
      } else {
        const formData = new FormData();
        formData.append("Image", file);
  
        try {
          const res = await axios.post(
            Variables.API_URL + "UploadMedia/UploadImageToServer",
            formData,
            {
              headers: {
                "Authorization": `Bearer ${token}`,
              },
            }
          );
  
          if (res.data) {
            // Add to local state so we can show & edit alt before saving to DB
            setUploadedImages(prev => [
              ...prev,
              {
                imagePath: res.data, // server path returned
                alt: "",
                imageTitle: file.name.split(".").slice(0, -1).join(".")
              }
            ]);
  
            console.log("Image uploaded successfully:", res.data);
          }
        } catch (ex) {
          console.log(ex);
        }
      }
    }
  
    if (count > 0) {
      toast.error(`${count} image(s) not accepted (over 2MB)`);
    }
  };

  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = Media.filter((data) => {
      return data.ImageTitle.search(value) != -1;
    });
    setFilteredData(result);
  };

  // Update alt text for an uploaded image
  const handleAltChange = (index, value) => {
    setUploadedImages(prev => {
      const updated = [...prev];
      updated[index].alt = value;
      return updated;
    });
  };

  // Save all uploaded images with alt text
  const saveUploadedImages = async () => {
    const token = Cookies.get("UserToken");
  
    for (let img of uploadedImages) {
      await fetch(Variables.API_URL + "UploadMedia/InsertMedia", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          image: img.imagePath,
          imageTitle: img.imageTitle,
          altText: img.alt,
          description: "",
          caption: "",
        }),
      });
    }
  
    toast.success("Images saved successfully!");
    setUploadedImages([]); // clear temporary list
    fetchMedia(); // refresh library
  };

  function fetchMedia() {
    const token = Cookies.get("UserToken");
    fetch(Variables.API_URL + "UploadMedia/GetMedia", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((Response) => Response.json())
      .then((Result) => {
        setMedia(Result);
        setFilteredData(Result)
      });
  }
  useEffect(() => {
    if(Cookies.get("UserToken") != undefined){
      fetchMedia();
    } else {
      navigate("/Login");
    }
  }, []);

  const handleAltTextChange = (e, mediaId) => {
    const newValue = e.target.value;
    setFilteredData(prevData =>
      prevData.map(img =>
        img.MediaId === mediaId ? { ...img, AltText: newValue } : img
      )
    );
  };
  
  const handleAltTextSave = async (mediaId, altText) => {
    try {
      const token = Cookies.get("UserToken");
      const response = await fetch(`${Variables.API_URL}UploadMedia/UpdateAltText`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          MediaId: mediaId,
          AltText: altText
        })
      });
    
      if (!response.ok) throw new Error("Failed to update Alt text");
    
      console.log("Alt text updated successfully!");
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <div className="card">
      <div className="card-header">
        <b> Product Image</b>
      </div>

      <Button
        className="me-2 btn btn-secondary btn-sm"
        onClick={() => handleShow(true)}
      >
       Add Product Images
      </Button>
     

      <Modal show={show}  onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add images to product gallery</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            defaultActiveKey="Library"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="Upload" title="Upload File">
              <div className="row mt-3">
                <Dropzone
                  onDrop={handleDrop}
                  accept="image/jpeg,image/png,image/jpg,image/svg"
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: "dropzone p-4 border" })}>
                      <input {...getInputProps()} />
                      <p>Drag & drop images here, or click to select files</p>
                    </div>
                  )}
                </Dropzone>
              </div>
            
              {/* Show uploaded images for alt editing */}
              {uploadedImages.length > 0 && (
                <div className="mt-4">
                  <div className="row">
                    {uploadedImages.map((img, idx) => (
                      <div key={idx} className="col-3 text-center">
                        <img
                          src={Variables.API_PUBLISHED + img.imagePath}
                          alt=""
                          className="img-fluid border"
                        />
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Alt text"
                          value={img.alt}
                          onChange={(e) => handleAltChange(idx, e.target.value)}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="mt-3 text-end">
                    <Button variant="primary" onClick={saveUploadedImages}>
                      Save All
                    </Button>
                  </div>
                </div>
              )}
            </Tab>

            <Tab eventKey="Library" title="Media Library">
              <div className="col-12">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-3">
                      <input
                        type="search"
                        className="form-control"
                        onChange={(e) => handleSearch(e)}
                        placeholder={"Search media by name"}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-12">
                      <p style={{ color: "red", fontWeight: "bold" }}>
                        *Important:* To update the Alt Text for each image, edit the input below and press <strong>Enter</strong>. Your changes will be saved immediately.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <PaginatedList
                    list={filteredData}
                    itemsPerPage={18}
                    displayRange={2}
                    showPrev={false}
                    showNext={false}
                    renderList={(list) => (
                      <>
                        <div className="row">
                          {list.map((image, id) => (
                            <div className="col-2" key={image.MediaId}>
                              <div className="imagecontainer">
                                <div className="form-check">
                                  <button
                                    className="btn btn-light"
                                    onClick={() => handleImage(image.MediaId, image.Image)}
                                  >
                                    <img
                                      alt="media"
                                      className="form-control"
                                      src={Variables.API_PUBLISHED + image.Image}
                                    />
                                  </button>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={image.AltText || ""}
                                    onChange={(e) => handleAltTextChange(e, image.MediaId)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        handleAltTextSave(image.MediaId, image.AltText);
                                      }
                                    }}
                                    placeholder={"Alt text"}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  />
                </div>
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ProductImage;